module.exports = __webpack_public_path__ + "static/media/skincarepro_v1_dk_1landing.9c41a348.png";